module.exports = __webpack_public_path__ + "img/JgIndex4.1a5a5f54.png";